import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs/internal/Observable";
class AjaxService {
  post(url: string, data: any): Observable<any> {
    return ajax({
      url: url,
      method: "POST",
      headers: {"content-type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  get(url: string, data?: any): Observable<any> {
    return ajax({
      url: url,
      method: "GET",
      headers: {"content-type": "application/json" },
      body: data
    });
  }

  put(url: string, data?: any): Observable<any> {
    return ajax({
      url: url,
      method: "PUT",
      headers: {"content-type": "application/json" },
      body: data
    });
  }
}

export default AjaxService;
